import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { getCurrentUser, onAuthStateChange, isAdminEmail } from '../services/authService';
import LoginForm from './LoginForm';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChange((currentUser) => {
      setUser(currentUser);
      setLoading(false);
      
      if (currentUser && isAdminEmail(currentUser.email)) {
        setShowLogin(false);
      } else if (currentUser && !isAdminEmail(currentUser.email)) {
        // User is signed in but not an admin
        setShowLogin(true);
      } else {
        // No user signed in
        setShowLogin(true);
      }
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (showLogin) {
    return (
      <LoginForm 
        onLoginSuccess={() => {
          setShowLogin(false);
        }} 
      />
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute; 